import styled from "../../../../styled";

export const StyledWrapper = styled.div`
  position: fixed;
  top: 3rem;
  bottom: 0;
  left: 0;
  right: 0;
`;
